import { Folder } from '@anm/api/modules/videoFolder';
import DropDownBreadcrumb from '@anm/components/DropDownBreadcrumb';
import { FC } from 'react';

import CustomizationBreadcrumbItem from './CustomizationBreadcrumbItem';
import { CustomizationBreadcrumbWrapper } from './Wrapper';
import {
  useBreadcrumbData,
  useOpenFolderCallback,
  ProjectBreadcrumbItem
} from './hooks';

export type CustomizationBreadcrumbProps = {
  projectId: string;
};

const CustomizationBreadcrumb: FC<CustomizationBreadcrumbProps> = ({
  projectId
}) => {
  const openFolder = useOpenFolderCallback();
  const breadcrumbData = useBreadcrumbData(projectId);

  if (!breadcrumbData) return null;

  return (
    <CustomizationBreadcrumbWrapper>
      <DropDownBreadcrumb<Folder | ProjectBreadcrumbItem>
        data={breadcrumbData}
        onClick={openFolder}
        renderItem={item => <CustomizationBreadcrumbItem {...item} />}
      />
    </CustomizationBreadcrumbWrapper>
  );
};
export default CustomizationBreadcrumb;
